import axios from 'axios';
const backendUrl = import.meta.env.VITE_BACKEND_URL;
export const loginService = async (credentials) => {
  const encodedUsername = encodeURIComponent(credentials.username);
  const encodedPassword = encodeURIComponent(credentials.password);
  const body = `username=${encodedUsername}&password=${encodedPassword}`;

  try {
    const response = await axios.post(`${backendUrl}/login`, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Login failed:', error);
    throw error;
  }
};

export const registerService = async (formData) => {
  const response = await axios.post(`${backendUrl}/register`, formData);
  return response.data;
};

export const forgetPasswordService = async (email) => {
  return axios.post(`${backendUrl}/reset-password`, { email });
};
export const resetPasswordService = async ({ token, password }) => {
  return axios.post(`${backendUrl}/confirm-reset-password?token=${token}&new_password=${password}`);
};

export const verifyLinkService = async ({ token }) => {
  const config = {
    headers: {
      'ngrok-skip-browser-warning': 1,
    },
  };

  const response = await axios.post(`${backendUrl}/verify_email?token=${token}`, config);
  return response.data;
};

export const verifyOtpService = async ({ email, otp, purpose }) => {
  const response = await axios.post(`${backendUrl}/check-otp`, { email, otp, purpose });
  return response.data;
};

export const SendOtp = async ({ email, purpose }) => {
  const response = await axios.post(`${backendUrl}/send-otp`, { email, purpose });
  return response.data;
};

export const registerUserService = async (formData) => {
  const response = await axios.post(`${backendUrl}/register-user`, formData);
  return response.data;
};

export const forgotPasswordService = async ({ email, purpose, otp, new_password }) => {
  const response = await axios.post(`${backendUrl}/forgot-password`, {
    email,
    purpose,
    otp,
    new_password,
  });
  return response.data;
};

// Google OAuth authentication services
export const googleSignInService = async (credential) => {
  const response = await axios.post(`${backendUrl}/google-login`, {
    token: credential,
  });
  return response.data;
};

export const googleSignUpService = async (credential) => {
  const response = await axios.post(`${backendUrl}/google-signup`, {
    credential,
  });
  return response.data;
};
